import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Accordion, AccordionDetails, AccordionSummary, Box, Typography } from "@mui/material";
import { t } from "i18next";
import type { FC } from "react";
import { LaunchAIContentCardsCarousel } from "../create-ai-content-carousel";

export const CreateContentCardsPane: FC = () => {
  return (
    <Box bgcolor="background.default" pl="var(--page-px)">
      <Accordion defaultExpanded sx={{ backgroundColor: "background.default", boxShadow: "none" }}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ pl: 0 }}>
          <Typography fontWeight={700} variant="body1">
            {t("Create New Content")}
          </Typography>
        </AccordionSummary>
        <AccordionDetails sx={{ px: 0 }}>
          <LaunchAIContentCardsCarousel analyticsIdPrefix="content-library" />
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};
